import { failedCross } from "~/assets/assets";
import { HubbleBranding } from "~/widgets/branding";
import { ButtonRegular } from "~/widgets/button";
import { BankTransferDetails } from "./bank_transfer_details";
import { HubbleRoute, PageAlignment, pushPage } from "~/shared_states/modal";
import Home from "../home/home";

export function FailedBankTransfer(props: { amount: number }) {
  return (
    <div class="relative flex h-full w-full flex-col items-start justify-start bg-baseTertiaryLight">
      <div class="mt-14 flex w-full flex-col items-center justify-between px-4 py-3">
        <p class="text-mediumBold uppercase text-textDark">Bank transfer</p>
        <p class="text-medium text-textNormal">Amount: ₹{props.amount}</p>
      </div>
      <div class="absolute left-1/2 top-1/2 flex -translate-x-1/2 -translate-y-3/4 flex-col items-center justify-center">
        <img src={failedCross} class="h-[72px] w-[72px]" alt="success" />
        <p class="mt-3 text-nowrap text-h1 text-errorDark">
          Bank transfer failed
        </p>
      </div>
      <div class="absolute bottom-4 left-4 right-4 flex flex-col gap-4">
        <p class="text-center text-medium text-textNormal">
          No incentive has been deducted from your balance
        </p>
        <div class="flex w-full items-center justify-center gap-3">
          <button
            onClick={() => {
              pushPage(
                () => <BankTransferDetails />,
                {
                  isModal: false,
                  alignment: PageAlignment.topRight,
                  offset: { top: 20, right: 20 },
                },
                HubbleRoute.BANK_TRANSFER
              );
            }}
            class="flex h-12 w-[161.5px] items-center justify-center rounded-[78px] border border-basePrimaryDark p-4 text-bold text-basePrimaryDark"
          >
            Try again
          </button>
          <ButtonRegular
            isEnabled={true}
            onClick={() => {
              pushPage(
                () => <Home />,
                {
                  isModal: false,
                  alignment: PageAlignment.bottom,
                  offset: { top: 20, right: 20 },
                },
                HubbleRoute.HOME
              );
            }}
            class="!w-[161.5px]"
          >
            Got it
          </ButtonRegular>
        </div>
        <HubbleBranding class="border-none" />
      </div>
    </div>
  );
}
